@if (includeRefreshButton) {
<div class="col-12 col-sm-6 col-lg-12">
    <button mat-icon-button style="float: right; bottom:25px;" (click)="emitRefresh()">
        <mat-icon>refresh</mat-icon>
    </button>
</div>
}

<div class="display-form">
    @for(item of displayValues; track item){
    <div class="display-form-item">
        <div class="display-form-label">{{item.key | convertDisplayLabels}}</div>
        <div class="display-form-value">
            @switch(item.type)
            {
            @case('displayUrl')
            {
            <text-formatter [content]="item.value.urlDisplayText"></text-formatter>
            <a class="formatted-text" href="{{item.value.urlLink}}" target="_blank">
                <mat-icon style="vertical-align: top;">open_in_new</mat-icon>
            </a>

            }
            @case('array')
            {
            <div *ngFor="let propVal of item.value"><text-formatter [content]="propVal"></text-formatter></div>
            }
            @default
            {
            <text-formatter [content]="item.value"></text-formatter>
            }
            }
        </div>
    </div>
    }
</div>